import { Trans } from "@lingui/react/macro";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation, useParams } from "react-router";
import { isStaticPagePath } from "@/utils/routes";
import TextButton from "./TextButton";

export default function BackToBookingButton() {
  const location = useLocation();
  const params = useParams<{ language?: string; campground?: string }>();
  const basePath = `/${params.language}/${params.campground}`;
  const candidate = (location.state as { returnTo?: unknown } | null)?.returnTo;
  const returnTo =
    typeof candidate === "string" &&
    candidate.startsWith(`${basePath}/`) &&
    !isStaticPagePath(candidate.split(/[?#]/)[0] ?? "")
      ? candidate
      : `${basePath}/${location.search}`;

  return (
    <TextButton
      component={Link}
      to={returnTo}
      startIcon={<ArrowBackIcon />}
      sx={{
        mb: 2,
      }}
    >
      <Trans>Back to booking</Trans>
    </TextButton>
  );
}
